import { apiSlice } from "./apiSlice";
import domain from "../util/domain";
const PROGRAMS_URL = `${domain}/api/programs`;

export const programsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllPrograms: builder.query({
      query: () => ({
        url: `${PROGRAMS_URL}`,
      }),
      providesTags: ["Programs"],
    }),
    getProgramById: builder.query({
      query: (id) => ({
        url: `${PROGRAMS_URL}/${id}`,
      }),
      providesTags: ["Program"],
    }),
    updateProgram: builder.mutation({
      query: (programData) => ({
        url: `${PROGRAMS_URL}/${programData.id}`,
        method: "PUT",
        body: programData,
      }),
      invalidatesTags: [
        "Program",
        "Programs",
        "Playlists",
        "Templates",
        "TemplatePrograms",
        "TemplateDates",
      ],
    }),
    addProgram: builder.mutation({
      query: (programData) => ({
        url: `${PROGRAMS_URL}`,
        method: "POST",
        body: programData,
      }),
      invalidatesTags: [
        "Program",
        "Programs",
        "Playlists",
        "Templates",
        "TemplatePrograms",
        "TemplateDates",
      ],
    }),
  }),
});

export const {
  useGetAllProgramsQuery,
  useUpdateProgramMutation,
  useAddProgramMutation,
  useGetProgramByIdQuery,
} = programsApiSlice;
